import { Psd2ConsentActions } from '../../actions/consumerDataPullSessionActions/psd2ConsentActions'
import { Psd2ConsentDto, BankError } from '#modules/Bank/Bank.types'

export enum Psd2ConsentStatus {
	IDLE = 'idle',
	CREATING = 'creatingConsent',
	CREATE_SUCCESS = 'createConsentSuccess',
	CREATE_FAILURE = 'createConsentFailure',
}

export interface Psd2ConsentState extends Psd2ConsentDto {
	status: Psd2ConsentStatus
	error?: BankError
}

const INITIAL_STATE: Psd2ConsentState = {
	status: Psd2ConsentStatus.IDLE,
	psD2ConsentTranslations: [],
	isConsentGiven: false,
}

export function creatingPsd2ConsentReducer(
	state: Psd2ConsentState,
	action: Psd2ConsentActions,
): Psd2ConsentState {
	switch (action.type) {
		case 'transactionClientApp/psd2Consent/createSucceeded':
			return {
				...state,
				status: Psd2ConsentStatus.CREATE_SUCCESS,
				isConsentGiven: true,
			}
		case 'transactionClientApp/psd2Consent/createFailed':
			return {
				...state,
				status: Psd2ConsentStatus.CREATE_FAILURE,
				error: action.payload,
			}
		default:
			return state
	}
}

export function createPsd2ConsentSuccessReducer(
	state: Psd2ConsentState,
	action: Psd2ConsentActions,
): Psd2ConsentState {
	switch (action.type) {
		case 'transactionClientApp/psd2Consent/create':
			return {
				...state,
				status: Psd2ConsentStatus.CREATING,
			}
		default:
			return state
	}
}

export function createPsd2ConsentFailureReducer(
	state: Psd2ConsentState,
	action: Psd2ConsentActions,
): Psd2ConsentState {
	switch (action.type) {
		case 'transactionClientApp/psd2Consent/create':
			return {
				...state,
				status: Psd2ConsentStatus.CREATING,
			}
		case 'transactionClientApp/psd2Consent/clearErrors':
			return {
				...state,
				error: undefined,
			}
		default:
			return state
	}
}

export function idleSessionReducer(
	state: Psd2ConsentState,
	action: Psd2ConsentActions,
): Psd2ConsentState {
	switch (action.type) {
		case 'transactionClientApp/psd2Consent/create':
			return {
				...state,
				status: Psd2ConsentStatus.CREATING,
			}
		case 'transactionClientApp/psd2Consent/clearErrors':
			return {
				...state,
				error: undefined,
			}
		case 'transactionClientApp/psd2Consent/setPsd2ConsentGiven':
			return {
				...state,
				...action.payload,
			}
		default:
			return state
	}
}

export default function reduce(
	state: Psd2ConsentState = INITIAL_STATE,
	action: Psd2ConsentActions,
): Psd2ConsentState {
	switch (state.status) {
		case Psd2ConsentStatus.IDLE:
			return idleSessionReducer(state, action)
		case Psd2ConsentStatus.CREATING:
			return creatingPsd2ConsentReducer(state, action)
		case Psd2ConsentStatus.CREATE_SUCCESS:
			return createPsd2ConsentSuccessReducer(state, action)
		case Psd2ConsentStatus.CREATE_FAILURE:
			return createPsd2ConsentFailureReducer(state, action)
		default:
			return state
	}
}
